module.exports = "/images/display-red.svg?fc0c154e03d482a28ce38f8ccc2d2a00";